import { useQuery } from '@tanstack/react-query';

import { getBlockedDomain } from '~/services/kyc/kyc.service.api';
import { EmailObject } from '~/domains/auth/hooks/useUserSchema';

export function useIsRestrictedDomain({ email }: { email: string }) {
  const emailObject = EmailObject();

  const isValidEmail = emailObject.safeParse(email);

  // eslint-disable-next-line local-rules/require-query-stale-time
  const { data } = useQuery({
    queryKey: ['blockedDomain', email],
    queryFn: () => getBlockedDomain(email),
    enabled: isValidEmail.success,
  });

  return isValidEmail.success ? data?.data?.blocked : false;
}
